import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=365ae2a2&scoped=true&"
var script = {}
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=365ae2a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365ae2a2",
  null
  
)

export default component.exports